module.exports = __webpack_public_path__ + "static/media/AMERICAN EXPRESS BLUEBOX.a1a2c823.png";